<template>
  <div class="notfound">
    <div>404</div>
    <div>Not Found</div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
}
</script>
<style lang="less" scoped>
.notfound {
  font-family: "SF UI Text Semibold", sans-serif;
  padding: 5rem 1rem;
  font-size: 1rem;
  color: #818388;

  div {
    margin: 0 auto;
    text-align: center;
  }
}
</style>
